import axios from 'axios';

export const state = {
  trades: [],
  tradesPagination: {},
  loading: false,
};

export const mutations = {
  setTrades(context, trades) {
    context.trades = trades;
    context.loading = false;
  },

  setTradesPagination(context, pagination) {
    context.tradesPagination = pagination;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getTrades({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const trades = await axios.get(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/trades/history?${query}`, options)
        .then(response => response.data);

      commit('setTrades', trades.data);
      commit('setTradesPagination', trades.pagination);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const tradesStore = {
  state,
  mutations,
  actions,
};

export default tradesStore;



// WEBPACK FOOTER //
// ./src/store/trades/tradesStore.js